<template>
    <div class="sa-list-component">
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ praticheSiatRowsNumber }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="praticheSiatRowsNumber" :per-page="perPage" :align="'right'" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table v-if="praticheSiatItems.length > 0" sticky-header ref="table" stacked="xl" striped :items="praticheSiatItems" :fields="fields" :current-page="1" :per-page="perPage" head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + (row.index + 1) }}
                    </template>
                    <template #cell(codice)="row">
                        <b-badge variant="primary">
                            {{ row.item.codice }}
                        </b-badge>
                    </template>
                    <template #cell(stato)="row">
                        <span :class="getClassBadge(row.item)">{{ row.item.stato }}</span>
                    </template>
                    <template #cell(bisogno)="row">
                        <span :class="getClassBadgeBisogno(row.item)">{{ row.item.bisogno }}</span>
                    </template>
                    <template #cell(statoVisualizzazione)="row">
                        <span class="sa-stato-visualizzazione-dot" :class="row.item.statoVisualizzazione === 'VISUALIZZATA' ? 'success' : 'danger'" v-b-tooltip.hover :title="row.item.statoVisualizzazione === 'VISUALIZZATA' ? 'VISUALIZZATA' : 'DA VISUALIZZARE'"></span>
                    </template>
                    <template #cell(actions)="row">
                        <b-button class="mr-1 ml-1 no-text" size="sm" variant="outline-primary width-sm no-text" @click="onClickApriDettaglioPratica(row.item)">
                            <i class="fas fa-eye"></i>
                        </b-button>
                    </template>
                </b-table>
                <NoDataComponent v-else ref="cmpNoDataComponent" title="Non sono presenti Pratiche" nome="no-data" subtitle="" icon="fas fa-clipboard" />
            </div>
        </div>
    </div>
</template>

<script>
import NoDataComponent from "../../../template/components/utility/NoDataComponent.vue";
import SiatMixin from "../mixins/SiatMixin";
// import praticaa from "./praticaa";
export default {
    components: { NoDataComponent },
    mixins: [SiatMixin],
    data() {
        return {
            items: [],
            currentPage: 1,
            perPage: 50,

            fields: [
                {
                    label: "",
                    key: "index",
                    thStyle: "width: 1.5rem",
                },
                {
                    label: "Codice Pratica",
                    key: "codice",
                },
                {
                    label: "Stato",
                    key: "stato",
                },

                {
                    label: "Assistito",
                    key: "assistito",
                },
                {
                    label: "Bisogno",
                    key: "bisogno",
                    formatter: (value) => {
                        if (value == null) {
                            return "--";
                        }
                        return value.toUpperCase();
                    },
                },
                {
                    label: "Regime",
                    key: "regime",
                    formatter: (value) => {
                        if (value == null) {
                            return "--";
                        }
                        return value.toUpperCase();
                    },
                },
                {
                    label: "Data Inizio",
                    key: "dataInizio",
                    formatter: (value) => {
                        if (value == null) {
                            return "--";
                        }
                        return value;
                    },
                },
                {
                    label: "Data Fine",
                    key: "dataFine",
                    formatter: (value) => {
                        if (value == null) {
                            return "--";
                        }

                        return this.formatDateTime(value);
                    },
                },
                {
                    label: "Visualizzazione",
                    key: "statoVisualizzazione",
                    thStyle: "width: 6rem; text-align: center",
                    tdClass: "text-center",
                },
                {
                    label: "",
                    key: "actions",
                },
            ],
        };
    },
    computed: {},
    watch: {
        currentPage: function () {
            this.loadData();
        },
    },
    methods: {
        loadData() {
            let sessionStorage = window.sessionStorage;
            let filter = {
                forPage: this.perPage,
                page: this.currentPage,
            };
            if (sessionStorage["filtroSiatPratiche"]) {
                let filtro = JSON.parse(sessionStorage["filtroSiatPratiche"]);
                filter = { ...filter, ...filtro };
            }
            this.praticheSiatLoadData(filter);
        },
        onClickApriDettaglioPratica(pratica) {
            this.$router.push("/pratichesiat/" + pratica.id);
        },
        getClassBadge(item) {
            switch (item.stato) {
                case "APERTA":
                    return "sa-ft-badge success";
                case "CHIUSA":
                    return "sa-ft-badge danger";
                default:
                    return "sa-ft-badge";
            }
        },
        getClassBadgeBisogno(item) {
            switch (item.bisogno) {
                case "COMPLESSO":
                    return "sa-ft-badge orange";
                default:
                    return "sa-ft-badge";
            }
        },
        getFormatoEuro(value) {
            return value.toLocaleString("it-IT", {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },
    },
};
</script>

<style scoped>
/* Card Pratica */
.sa-siat-card-pratica {
    border: none;
    border-radius: 12px;
    margin-bottom: 25px;
    overflow: hidden;
}

.sa-siat-card-header-custom {
    background: #fff;
    border-bottom: 1px solid #edf2f7;
    padding: 15px 20px;
}

/* Sezione Prestazioni */
.sa-siat-prestazione-item {
    border: 1px solid #e2e8f0;
    margin: 8px 20px;
    border-radius: 8px;
    background: #fff;
    transition: all 0.2s ease;
}

.sa-siat-prestazione-header {
    padding: 12px 15px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.sa-siat-prestazione-header:hover {
    background: #f8fafc;
}

/* Colori per Figura */
.sa-siat-border-IP {
    border-left: 5px solid #3498db;
}

.sa-siat-border-FISIO {
    border-left: 5px solid #2ecc71;
}

.sa-siat-border-OSS {
    border-left: 5px solid #e67e22;
}

.sa-siat-border-PSIC {
    border-left: 5px solid #9b59b6;
}

.sa-siat-border-MED {
    border-left: 5px solid #e74c3c;
}

.sa-siat-text-IP {
    color: #3498db !important;
}

.sa-siat-text-FISIO {
    color: #2ecc71 !important;
}

.sa-siat-text-OSS {
    color: #e67e22 !important;
}

.sa-siat-text-PSIC {
    color: #9b59b6 !important;
}

.sa-siat-text-MED {
    color: #e74c3c !important;
}

.sa-siat-label-pai {
    font-weight: bold;
    color: #7f8c8d;
    text-transform: uppercase;
    font-size: 0.95rem;
}

.sa-siat-valore-pai {
    color: #2c3e50;
    font-weight: 600;
}

.sa-siat-cols {
    padding-right: 25px;
    padding-left: 25px;
}

.sa-siat-text-data {
    color: #c20000;
}

.sa-siat-text-indirizzo {
    font-size: 1rem;
}

.sa-siat-data {
    color: #e83e8c;
}

.sa-siat-badge {
    /* display: block; */
    font-size: 1rem;
    max-width: 200px;
}

.sa-siat-badge-aperta {
    color: #07af07;
}

.sa-siat-data-complesso {
    color: #e67e22;
}

.sa-stato-visualizzazione-dot {
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 80%;
    cursor: default;
}

.sa-stato-visualizzazione-dot.success {
    background-color: #28a745;
}

.sa-stato-visualizzazione-dot.danger {
    background-color: #dc3545;
}
</style>
